export default "__VITE_ASSET__BzL2wASN__"